// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2di0n","imageUploader":"EGiftCard_imageUploader__1LHnM"};